import React from 'react';
import MainContainer from '../mainContainer';
import Study from './study';

class ComplicatedWires extends React.Component {
    render() {
        return (
            <MainContainer>
                <Study />
            </MainContainer>
        );
    }
}

export default ComplicatedWires;
